export const LOAD_EVENTLOG = "LOAD_EVENTLOG";
export const LOAD_EVENTLOG_SUCCESS = "LOAD_EVENTLOG_SUCCESS";
export const LOAD_EVENTLOG_FAILED = "LOAD_EVENTLOG_FAILED";

export const LOAD_EVENTLOG_DETAILS = "LOAD_EVENTLOG_DETAILS";
export const LOAD_EVENTLOG_DETAILS_SUCCESS = "LOAD_EVENTLOG_DETAILS_SUCCESS";
export const LOAD_EVENTLOG_DETAILS_FAILED = "LOAD_EVENTLOG_DETAILS_FAILED";

